import { render, staticRenderFns } from "./UcAccountHeader.yaml?vue&type=template&id=0f1b445e&component"
import script from "./UcAccountHeader.yaml?vue&type=script&lang=ts&component"
export * from "./UcAccountHeader.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports